import { render, staticRenderFns } from "./WorkerList.vue?vue&type=template&id=8374f514&scoped=true"
import script from "./WorkerList.vue?vue&type=script&lang=ts"
export * from "./WorkerList.vue?vue&type=script&lang=ts"
import style0 from "./WorkerList.vue?vue&type=style&index=0&id=8374f514&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8374f514",
  null
  
)

export default component.exports